var map = {
	"./AKBKTRIS.png": "f966",
	"./DEFAULT.png": "8225",
	"./ININAL.png": "2d06",
	"./ISBKTRIS.png": "914d",
	"./MERGENXXX.png": "f590",
	"./PAPARA.png": "118c",
	"./TCZBTR2A.png": "b122",
	"./TEBUTRIS.png": "30ed",
	"./TGBATRIS.png": "150d",
	"./TRHBTR2A.png": "bfbe",
	"./YAPITRISFEX.png": "9a16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90e9";